import React, { FC } from 'react'

export interface VipCrownSvgProps {
  width?: string | number
  height?: string | number
}

export const VipCrown3Svg: FC<VipCrownSvgProps> = ({
  width = 144,
  height = 124,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 144 124"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFCF62"
        d="M71.97 11L35.713 59.805 1 32.741l13.2 81.78h115.539l13.2-81.78-34.713 27.064z"
      />
      <path
        fill="#FFF"
        d="M52.323 99.639l-8.269-25.46h5.762l5.693 17.899h.071l5.764-17.9h5.798l-8.484 25.46zm17.003 0h5.62v-25.46h-5.62zM89.872 86.16c.644 0 1.264-.048 1.862-.143a4.37 4.37 0 001.575-.553c.453-.273.817-.66 1.09-1.158.275-.5.414-1.153.414-1.963 0-.807-.139-1.462-.413-1.96a2.992 2.992 0 00-1.09-1.158 4.344 4.344 0 00-1.576-.553 11.806 11.806 0 00-1.862-.143h-4.367v7.63h4.367zm1.54-11.982c1.597 0 2.96.23 4.08.694 1.122.464 2.034 1.077 2.738 1.837a7.036 7.036 0 011.538 2.603 9.65 9.65 0 010 6.045 6.993 6.993 0 01-1.538 2.621c-.704.761-1.616 1.373-2.738 1.838-1.12.46-2.483.694-4.08.694h-5.907v9.129h-5.62v-25.46h11.527zm-19.389-5.892l-4.58-6.766 4.58-6.884 4.432 7.061z"
      />
      <path
        fill="#F4C456"
        d="M116.393 65.176s0-4.086 3.179-7.264 13.85-11.804 13.85-11.804 4.542-2.27 3.861 1.816c-.681 4.086-9.537 56.752-9.537 56.752s-.908 6.13-5.45 6.13h-9.31s-2.27-.909-1.362-5.449c.909-4.54 4.542-28.376 4.769-40.18"
      />
      <path
        fill="#FCE4A2"
        d="M64.095 28.04l6.51-9.232s1.664-1.816 3.33 1.21c1.665 3.027.454 9.384-2.12 12.108-2.573 2.725-5.601 3.633-7.72 2.876-2.12-.757-2.423-3.784 0-6.962"
      />
    </g>
  </svg>
)
